@if (teaItemProduct) {
  <!--
  Special block layout to support the following layout:
  Desktop: A C
  B
  Mobile:  A
  C
  B
  -->
  <!-- Parent container -->
  <div class="flex flex-col md:grid md:grid-cols-2 md:gap-4 p-2 pt-0  text-neutral-700">
    <div>
      <!-- Block A content -->
      <div class="relative overflow-hidden group">
        <!-- Add zoom mode toggle button -->
        <button
          (click)="toggleZoomMode()"
          class="absolute top-2 right-2 z-10 bg-white/80 p-2 rounded-full shadow hover:bg-white">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            @if (!isLightboxMode) {
              <g>
                <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6" />
              </g>
            }
            @if (isLightboxMode) {
              <g>
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
              </g>
            }
          </svg>
        </button>
        <img
          [ngSrc]="(imageUrl | imageModifier:{width:2048} | async) || ''"
          alt="{{ teaItemProduct.name }}"
          class="w-full mt-2 rounded dropshadow transition-transform duration-200"
          [class.cursor-zoom-in]="!isLightboxMode"
          [class.cursor-pointer]="isLightboxMode"
          [ngClass]="{'scale-[4.0]': isZoomed}"
          [style.transform-origin]="transformOrigin"
          (mousemove)="onImageMouseMove($event)"
          (mouseenter)="onImageMouseEnter()"
          (mouseleave)="onImageMouseLeave()"
          (click)="onImageClick()"
          width="2048"
          height="2048"
          priority
          />
        <!-- Add lightbox overlay -->
        @if (showLightbox) {
          <div
            class="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
            (click)="closeLightbox()">
            <img [ngSrc]="(imageUrl | imageModifier:{width:2048} | async) || ''"
              alt="{{ teaItemProduct.name }}"
              class="max-h-[90vh] max-w-[90vw] object-contain"
              (click)="$event.stopPropagation()"
              width="2048"
              height="2048"/>
            <button
              (click)="closeLightbox()"
              class="absolute top-4 right-4 text-white hover:text-gray-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        }
      </div>
      <div class="flex items-center gap-2 pt-2">
        <!-- <button class="text-gray-600 hover:text-gray-800" (click)="previousImage()">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button> -->
      <!-- <div class="flex gap-2 overflow-x-hidden"> -->
      <div class="flex gap-2 flex-wrap">
        @for (image of images; track image; let i = $index) {
          <img
            [ngSrc]="(image.url | imageModifier:{width:160} | async) || ''"
            [alt]="image.name"
            [title]="image.description"
            class="w-20 h-20 object-cover cursor-pointer hover:opacity-75 flex-shrink-0 rounded dropshadow"
            [class.border-2]="i === imageIndex"
            [class.border-green-800]="i === imageIndex"
            (click)="setImage(i)"
            width="80"
            height="80" />
        }
      </div>
      <!-- <button class="text-gray-600 hover:text-gray-800" (click)="nextImage()">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </button> -->
  </div>
</div>
<div class="md:row-span-2">
  <!-- Block C content -->
  <h1 class="text-3xl mt-2 font-bold text-green-800">{{ teaItemProduct.name }}
    @if (!['powder', 'wares'].includes(teaItemProduct.teaItem.form)) {
      <span
        class="text-xl text-gray-400 block md:inline-block robots-only"
        >
        <a routerLink="/tea-type/{{teaItemProduct.teaItem.teaType.slug}}" class="underline decoration-1">{{ teaItemProduct.teaItem.teaType.name }}</a>
        from
        <a routerLink="/tea-region/{{teaItemProduct.teaItem.teaRegion.slug}}" class="underline decoration-1">{{ teaItemProduct.teaItem.teaRegion.name }}</a>
      </span>
    }
  </h1>
  <div class="mt-5 md:pt-0 markdown" [innerHTML]="contentMap.get('Brief') ?? '' | markdown | async">
  </div>
  @if (true || !isOutOfStock()) {
    <div class="pt-5 markdown">
      <div class="bg-white rounded-lg shadow p-6 space-y-4">
        <div class="flex justify-between items-center">
          <span class="text-2xl font-bold text-green-800">
            {{ teaItemProduct.price | currency:'AUD' }}
          </span>
          <span class="text-gray-600">
            {{ teaItemProduct.weight }}g
          </span>
        </div>
        @if (hasHighStock()) {
          <div class="flex items-center justify-between bg-gray-50 p-3 rounded">
            <span class="text-gray-700">Stock Status:</span>
            <span [class.text-green-600]="hasHighStock()"
              [class.text-amber-600]="hasLowStock()"
              [class.text-red-600]="isOutOfStock()">
              {{ isOutOfStock() ? 'Out of Stock' :
              hasLowStock() ? 'Low Stock' : 'In Stock' }}
            </span>
          </div>
        }
        @if (hasLowStock()) {
          <div class="text-amber-600 text-sm flex items-center gap-2 bg-amber-50 p-3 rounded">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
            Low stock - order soon!
          </div>
        }
        <div class="flex items-center gap-2">
          <button class="px-4 py-2 border rounded"
            (click)="decrementQuantity()"
          [disabled]="cartItem.quantity <= 1">−</button>
          <span class="inline-block w-8 text-center font-medium">{{cartItem.quantity}}</span>
          <button class="px-4 py-2 border rounded"
            (click)="incrementQuantity()"
          [disabled]="cartItem.quantity >= maxAllowed()">+</button>
        </div>
          <button class="w-full bg-green-800 text-white py-3 rounded-lg hover:bg-green-700 
                         disabled:bg-gray-300 disabled:cursor-not-allowed
                         transition duration-200"
          [disabled]="teaItemProduct.stock === 0 || cartItem.quantity > maxAllowed()"
          (click)="addToCart()">
          {{ teaItemProduct.stock === 0 ? 'Out of Stock' : 'Add to Cart' }}
        </button>
      </div>
    </div>
  } @else {
    <div class="bg-gray-50 p-6 rounded-lg shadow text-center">
      <h2 class="text-2xl font-bold text-green-800">Coming Soon!</h2>
      <p class="text-gray-600">This product is not yet available for purchase.</p>
      <p class="text-gray-600">Subscribe to our newsletter to get notified when it's available.</p>
      <tea-shop-fe-subscribe-block></tea-shop-fe-subscribe-block>
    </div>
  }
  <tea-shop-fe-truncated-markdown
    class="p-2"
    [text]="contentMap.get('Description') ?? ''"
    [maxLength]="35"
  ></tea-shop-fe-truncated-markdown>
</div>
<div class="-no-md:-mt-24">
  <!-- Block B content -->
  @if (teaItemProduct.teaItem.flavours.length) {
    <span class="font-semibold">Flavours:&nbsp;</span>
  }
  @for (flavour of teaItemProduct.teaItem.flavours; track flavour; let i = $index) {
    <span>
      <a routerLink="/tea-flavour/{{flavour.slug}}" class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">{{ flavour.name }}</a>
    </span>
  }
  @if (contentMap.get('Info Block')) {
    <div class="pt-5 -ml-2 pl-8 text-green-800 markdown info-block" [innerHTML]="contentMap.get('Info Block') ?? '' | markdown | async"></div>
  }
  @if (getTabs().length > 0) {
    <div>
      <div class="border-b border-gray-200">
        <nav class="-mb-px flex">
          @for (tab of getTabs(); track tab) {
            <button
              class="py-2 px-4 border-b-2 font-medium text-sm"
              [class.border-green-800]="currentTab === tab"
              [class.text-green-800]="currentTab === tab"
              [class.border-transparent]="currentTab !== tab"
              [class.text-gray-500]="currentTab !== tab"
              [class.hover:text-gray-700]="currentTab !== tab"
              (click)="setCurrentTab(tab)">
              {{ tab }}
            </button>
          }
        </nav>
      </div>
      <div>
        @for (tab of getTabs(); track tab) {
          <div>
            <h3 class="text-2xl font-bold hidden">{{ tab }}</h3>
            <div
              [class.hidden]="currentTab !== tab"
              >
              <div class="pt-5 markdown"
                [innerHTML]="getTabContent(tab) | markdown | async">
              </div>
              @if (tab === 'Brewing Instructions' && brewingInfographics.length > 0) {
                <div class="relative">
                  <!-- Previous/Back button -->
                  @if (brewingInfographics.length > 1) {
                    <button
                      (click)="previousBrewingImage()"
                      class="absolute left-2 top-1/2 -translate-y-1/2 bg-white bg-opacity-80 p-2 rounded-full shadow hover:bg-white z-10">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                      </svg>
                    </button>
                  }
                  <div class="relative">
                    <img [ngSrc]="(brewingInfographics[currentBrewingImageIndex].url | imageModifier:{width:1600} | async) || ''"
                      alt="Brewing Instructions"
                      class="w-full mt-2 rounded drop-shadow transition-opacity duration-300 ease-in-out"
                      width="1600"
                      height="1600" />
                  </div>
                  <!-- Next button -->
                  @if (brewingInfographics.length > 1) {
                    <button
                      (click)="nextBrewingImage()"
                      class="absolute right-2 top-1/2 -translate-y-1/2 bg-white bg-opacity-80 p-2 rounded-full shadow hover:bg-white z-10">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  }
                  @if (brewingInfographics.length > 1) {
                    <div
                      class="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                      @for (_ of brewingInfographics; track _; let i = $index) {
                        <button
                          (click)="setBrewingImageIndex(i)"
                          [ngClass]="{
                            'w-2 h-2 rounded-full bg-white': true,
                            'opacity-100': i === currentBrewingImageIndex,
                            'opacity-50': i !== currentBrewingImageIndex
                          }">
                        </button>
                      }
                    </div>
                  }
                </div>
              }
              @if (tab === 'Flavour Profile' && flavourInfographics.length>0) {
                <div>
                  <img [ngSrc]="(flavourInfographics[0].url | imageModifier:{width:1600} | async) || ''"
                    alt="Flavour Profile"
                    class="w-full mt-2 rounded dropshadow"
                    width="1600"
                    height="1600" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
  <!-- Accordions Section -->
  @if (getAccordions().length > 0) {
    <div class="mt-8 space-y-2">
      <div class="flex justify-end mb-2">
        <button
          (click)="toggleAllAccordions()"
          class="px-3 py-1 text-sm font-medium text-green-800 bg-green-50 hover:bg-green-100 rounded-md">
          {{ hasExpandedAccordions() ? 'Collapse All' : 'Expand All' }}
        </button>
      </div>
      @for (accordion of getAccordions(); track accordion) {
        <div
          class="border rounded-lg overflow-hidden">
          <button
            (click)="toggleAccordion(accordion)"
            class="w-full px-4 py-3 text-left bg-gray-50 hover:bg-gray-100 flex justify-between items-center"
            >
            <span class="font-semibold text-green-800">{{ accordion }}</span>
            <svg
              class="w-5 h-5 transition-transform duration-200"
              [class.rotate-180]="isAccordionExpanded(accordion)"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              >
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </button>
          <div
            class="overflow-hidden transition-[max-height] duration-300 ease-in-out"
            [style.max-height]="isAccordionExpanded(accordion) ? '1000px' : '0'"
            >
            <div class="px-4 py-3 bg-white">
              <div class="markdown" [innerHTML]="getAccordionContent(accordion) | markdown | async">
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
</div>
} @else {
  @if (errors.length > 0) {
    <div class="m-2">
      <div class="bg-red-500 text-white p-4 rounded">
        <h2 class="text-xl font-bold">Something went wrong:</h2>
        <ul>
          @for (error of errors; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    </div>
  }
  @if (errors.length === 0) {
    <div class="m-2">
      <div class="animate-pulse">
        <div class="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
        <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
        <div class="h-4 bg-gray-300 rounded w-2/3 mb-2"></div>
        <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
        <div class="h-4 bg-gray-300 rounded w-2/5 mb-2"></div>
        <div class="h-4 bg-gray-300 rounded w-3/5 mb-2"></div>
        <div class="h-4 bg-gray-300 rounded w-1/3 mb-2"></div>
        <div class="h-4 bg-gray-300 rounded w-1/6 mb-2"></div>
      </div>
    </div>
  }
}


